import { Box, Button, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useState } from "react";
import { LIGHT_GREY } from "styles/oneOffColor";

import { trackEvent } from "utils/tracking";

interface Props {
  handleNext: (method?: TemplateMethod) => void;
  isDialog?: boolean;
}

enum TemplateMethod {
  from_scratch = "from_scratch",
  use_bento_ai = "use_bento_ai",
}

const styles = {
  aiCard: (isDialog?: boolean) => ({
    p: 3,
    backgroundColor: isDialog ? "transparent" : "white",
    border: `1px solid ${LIGHT_GREY}`,
    borderRadius: 4,
    cursor: "pointer",
    "&:hover": {
      border: `1px solid ${grey[800]}`,
    },
  }),
  nonAiCard: (isDialog?: boolean) => ({
    p: 3,
    backgroundColor: isDialog ? "transparent" : "white",
    border: `1px solid ${LIGHT_GREY}`,
    borderRadius: 4,
    cursor: "pointer",
    "&:hover": {
      border: `1px solid ${grey[800]}`,
    },
  }),
  active: {
    border: `2px solid`,
    borderColor: "primary.main",
  },
  dialogAnnotation: {
    backgroundColor: "#f1f3f3",
    borderRadius: 6,
    color: "green.main",
    width: "max-content",
    px: 2,
    py: 1,
    display: "block",
    margin: "auto",
    mb: 2,
  },
};

const PickTemplateMethodForm = ({ handleNext, isDialog = true }: Props) => {
  const [selectedMethod, setSelectedMethod] = useState<TemplateMethod | null>(
    null,
  );

  const pickMethod = (method: TemplateMethod) => {
    trackEvent("Create Template - Pick Method", {
      method,
    });
    setSelectedMethod(method);
  };

  return (
    <>
      {isDialog && (
        <>
          <Box sx={styles.dialogAnnotation}>
            💭 Let's answer a few questions
          </Box>

          <Typography
            variant="h3"
            gutterBottom
            sx={{ textAlign: "center", fontSize: { xs: 20, md: 28 } }}
          >
            Would you like us to help you create your template?
          </Typography>
        </>
      )}

      <Grid container justifyContent="center">
        <Grid container gap={3} sx={{ my: 3, maxWidth: 800 }}>
          <Grid
            item
            xs={12}
            md={6}
            sx={[
              styles.aiCard(isDialog),
              selectedMethod === TemplateMethod.use_bento_ai
                ? styles.active
                : {},
            ]}
            onClick={() => pickMethod(TemplateMethod.use_bento_ai)}
          >
            <Typography variant="h4" textAlign="center">
              Yes 🚀
            </Typography>

            <Typography
              textAlign={"center"}
              color="textSecondary"
              sx={{ mt: 2 }}
            >
              Our AI will craft a ready-to-use template for you
            </Typography>
          </Grid>

          <Grid
            item
            xs
            md
            sx={[
              styles.nonAiCard(isDialog),
              selectedMethod === TemplateMethod.from_scratch
                ? styles.active
                : {},
            ]}
            onClick={() => pickMethod(TemplateMethod.from_scratch)}
          >
            <Typography variant="h4" textAlign={"center"}>
              No
            </Typography>

            <Typography
              textAlign={"center"}
              color="textSecondary"
              sx={{ mt: 2 }}
            >
              I will craft my template from scratch
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <Grid container justifyContent={"center"}>
        <Button
          sx={{ minWidth: 200, py: 1 }}
          variant="contained"
          onClick={() => handleNext(selectedMethod!)}
          disableElevation
          disabled={!selectedMethod}
        >
          Next
        </Button>
      </Grid>
    </>
  );
};

export default PickTemplateMethodForm;
